import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const StrategySidebar = ({ strategyInfo, maturityLevel, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);
  
  if (!strategyInfo || !strategyInfo.maturityLevels || !strategyInfo.maturityLevels[maturityLevel]) {
    return null;
  }
  
  const levelInfo = strategyInfo.maturityLevels[maturityLevel];
  
  // Helper function to format the content with proper styling
  const formatContent = (text) => {
    // Split into paragraphs
    return text.split('\n\n').map((paragraph, i) => {
      // Check if paragraph contains emoji or special formatting
      if (paragraph.includes('✅') || paragraph.includes('⚠️') || paragraph.includes('🛠️') || paragraph.includes('⚙️')) {
        // Bold the heading
        const parts = paragraph.split('\n');
        const heading = parts[0];
        const rest = parts.slice(1).join('\n');
        
        // Determine which emoji is being used
        const emoji = heading.includes('✅') ? '✅' : 
                     heading.includes('⚠️') ? '⚠️' : 
                     heading.includes('🛠️') ? '🛠️' :
                     heading.includes('⚙️') ? '⚙️' : '';
        
        return (
          <div key={i} className="mb-6">
            <h4 className="font-bold text-base mb-2 flex items-center">
              <span className="mr-2">{emoji}</span>
              <span>{heading.replace(/[✅⚠️🛠️⚙️]/g, '').trim()}</span>
            </h4>
            <div className="whitespace-pre-line text-sm pl-7">
              {rest.split('\n').map((line, j) => (
                <p key={j} className="mb-2">{line}</p>
              ))}
            </div>
          </div>
        );
      }
      
      return (
        <p key={i} className="mb-4 text-gray-700 whitespace-pre-line">
          {paragraph}
        </p>
      );
    });
  };
  
  return (
    <div 
      className={`fixed inset-y-0 right-0 w-96 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 overflow-hidden flex flex-col ${
        isVisible ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      {/* Header */}
      <div className="bg-blue-600 text-white p-4 flex justify-between items-center">
        <h2 className="font-bold text-lg">
          {strategyInfo.title} - ML{maturityLevel.substring(2)}
        </h2>
        <button 
          onClick={onClose}
          className="text-white hover:text-blue-200"
        >
          <X className="w-6 h-6" />
        </button>
      </div>
      
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-5">
        <h3 className="text-xl font-semibold mb-4 text-blue-800">{levelInfo.title}</h3>
        <div className="prose max-w-none">
          {formatContent(levelInfo.description)}
        </div>
      </div>
    </div>
  );
};

export default StrategySidebar; 